import { Plug } from 'lucide-react';
import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';

/*
 * Інтеграції (М14 «Комунікації й сповіщення», М16 «Інтеграції та відкритий API», розділи плану 7.1 і 7.10):
 * інтеграційний центр (каталог конекторів зі станом, картка конектора з перевіркою, секретами, областями доступу
 * й журналом), Google Workspace (ключ, функції, делегування, каталог, Calendar, Drive, Google Chat), реєстр областей
 * доступу, черга завдань із чергою помилок, сповіщення організації (типові правила, вихідна черга, показники,
 * налаштування працівника), вхідні вебхуки й поштові скриньки, Push і Telegram.
 * У меню — лише адміністраторам (область доступу «admin»). Особисті налаштування сповіщень будь-якого працівника —
 * експортована панель notifications/MyNotificationsPanel (підключається у «Налаштуваннях»).
 */

const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const connectorsModule: ModuleDefinition = {
  key: 'connectors',
  label: 'Інтеграції',
  icon: Plug,
  basePath: '/connectors',
  scope: 'admin',
  order: 80,
  routes: [
    {
      ...page(() => import('./ConnectorsLayout')),
      children: [
        { index: true, ...page(() => import('./center/CenterPage')) },
        { path: 'c/:key', ...page(() => import('./center/ConnectorPage')) },
        {
          path: 'google',
          ...page(() => import('./google/GoogleLayout')),
          children: [
            { index: true, ...page(() => import('./google/SetupPage')) },
            { path: 'directory', ...page(() => import('./google/DirectoryPage')) },
            { path: 'calendar', ...page(() => import('./google/CalendarPage')) },
            { path: 'drive', ...page(() => import('./google/DrivePage')) },
            { path: 'chat', ...page(() => import('./google/ChatPage')) },
          ],
        },
        { path: 'scopes', ...page(() => import('./scopes/ScopesPage')) },
        { path: 'jobs', ...page(() => import('./jobs/JobsPage')) },
        { path: 'notifications', ...page(() => import('./notifications/NotificationsAdminPage')) },
        { path: 'inbound', ...page(() => import('./inbound/InboundPage')) },
        { path: 'messaging', ...page(() => import('./messaging/MessagingPage')) },
      ],
    },
  ],
};

export default connectorsModule;
